// Canonical Maidenhead grid validation: FF (A-R), then 2 digits, optionally a
// subsquare (A-X x2) and an extended square (2 digits). Used to drop malformed
// grids from imported logs (e.g. Log4OM exporting "EFL02") instead of storing junk.
var GRID_RE = /^[A-R]{2}[0-9]{2}([A-X]{2}([0-9]{2})?)?$/i;
export function isValidGrid(grid) {
  return GRID_RE.test(String(grid || "").trim());
}

// Maidenhead Grid Locator to Lat/Lon converter
export function gridToLatLon(grid) {
  if (!grid || grid.length < 4) return null;
  var g = grid.toUpperCase();
  if (g.charCodeAt(0) < 65 || g.charCodeAt(0) > 82) return null;
  if (g.charCodeAt(1) < 65 || g.charCodeAt(1) > 82) return null;
  // Positions 3 and 4 (index 2,3) MUST be digits. Malformed grids from some
  // loggers (e.g. Log4OM exporting "EFL02") would otherwise yield NaN coordinates
  // that crash the map (Leaflet throws on Invalid LatLng). Reject them here so the
  // caller can fall back to the DXCC entity centroid.
  if (g[2] < "0" || g[2] > "9" || g[3] < "0" || g[3] > "9") return null;
  var lonBase = (g.charCodeAt(0) - 65) * 20 - 180 + parseInt(g[2]) * 2;
  var latBase = (g.charCodeAt(1) - 65) * 10 - 90 + parseInt(g[3]);
  var res;
  if (g.length >= 6 && g.charCodeAt(4) >= 65 && g.charCodeAt(4) <= 88 && g.charCodeAt(5) >= 65 && g.charCodeAt(5) <= 88) {
    res = {
      lat: latBase + (g.charCodeAt(5) - 65) / 24 + 1 / 48,
      lon: lonBase + (g.charCodeAt(4) - 65) * 2 / 24 + 1 / 24
    };
  } else {
    res = { lat: latBase + 0.5, lon: lonBase + 1 };
  }
  // Final safety net: never return non-finite coordinates.
  if (!isFinite(res.lat) || !isFinite(res.lon)) return null;
  return res;
}

// Haversine distance in km
export function haversine(lat1, lon1, lat2, lon2) {
  var R = 6371;
  var dLat = (lat2 - lat1) * Math.PI / 180;
  var dLon = (lon2 - lon1) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

// Reverse: lat/lon to Maidenhead grid locator (6 char)
export function latLonToGrid(lat, lon) {
  if (lat == null || lon == null) return "";
  var lng = lon + 180;
  var la = lat + 90;
  var f1 = String.fromCharCode(65 + Math.floor(lng / 20));
  var f2 = String.fromCharCode(65 + Math.floor(la / 10));
  var f3 = String(Math.floor((lng % 20) / 2));
  var f4 = String(Math.floor(la % 10));
  var f5 = String.fromCharCode(97 + Math.floor((lng % 2) * 12));
  var f6 = String.fromCharCode(97 + Math.floor((la % 1) * 24));
  return f1 + f2 + f3 + f4 + f5 + f6;
}
